<template>
  <div class="app-wrapper relative overflow-hidden">

    <Decorations />

    <!-- FLOATING BUBBLES -->
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>

    <!-- CATEGORY -->
    <div class="flex justify-center mt-6">
      <CategoryButtons v-model="lang" />
    </div>

    <!-- HEADER SCROLL -->
    <HeaderScroll :lang="lang" />

    <!-- MAIN BUTTON -->
    <div class="flex justify-center mb-4">
      <MainButton :lang="lang" />
    </div>

    <!-- Products -->
    <ProductsGrid :lang="lang" />

    <ImageTextSection :lang="lang" />

    <Collaborate :lang="lang" />

    <FooterFairGround />
  </div>
</template>

<script>
import CategoryButtons from "./components/CategoryButtons.vue"
import HeaderScroll from "./components/HeaderScroll.vue"
import MainButton from "./components/MainButton.vue"
import ProductsGrid from "./components/ProductsGrid.vue"
import Decorations from "./components/Decorations.vue"
import ImageTextSection from "./components/ImageTextSection.vue"
import FooterFairGround from "./components/FooterFairGround.vue"
import Collaborate from "./components/Collaborate.vue"

export default {
  components: {
    CategoryButtons,
    HeaderScroll,
    MainButton,
    Decorations,
    ProductsGrid,
    ImageTextSection,
    FooterFairGround,
    Collaborate
  },
  data() {
    return {
      lang: "en",
    }
  }
}
</script>

<style>
.app-wrapper {
  min-height: 100vh;
  background: linear-gradient(
    to bottom,
    #9fd7ff,
    #ffe9a9,
    #ffd3f3,
    #d8caff,
    #b7f5d0
  );
  font-family: "Poppins", sans-serif;
}

/* BUBBLES */
@keyframes floatBubble {
  0% { transform: translateY(0); opacity: 0.9; }
  50% { transform: translateY(-35px); opacity: 0.6; }
  100% { transform: translateY(0); opacity: 0.9; }
}

.bubble {
  position: absolute;
  top: 20%;
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.4);
  border-radius: 50%;
  box-shadow: 0 0 12px rgba(255,255,255,0.9);
  animation: floatBubble 4s ease-in-out infinite;
}

.bubble:nth-child(1) { left: 12%; animation-delay: 0s; }
.bubble:nth-child(2) { left: 42%; width: 22px; height: 22px; animation-delay: 1s; }
.bubble:nth-child(3) { left: 63%; width: 34px; height: 34px; animation-delay: 2s; }
.bubble:nth-child(4) { left: 82%; width: 26px; height: 26px; animation-delay: 3s; }
</style>
